
















































































import { Component, Vue } from 'vue-property-decorator';
import PreCollectionStore, {
  PreCollectionsParams,
  PreCollectionStoreInterface,
} from '@/resource/pre-collection/pre-collection.store';
import { Subject, SubjectType } from '@/resource/subject/subject.model';
import {
  PreCollection,
  PreCollectionSortBy,
  PreCollectionType,
  preCollectionTypeList,
} from '@/resource/pre-collection/pre-collection.model';
import PreCollectionSearch from '@/main-components/pre-collections-new/PreCollectionSearch.vue';
import PreCollectionSubject from '@/components/pre-collections/PreCollectionSubject.vue';
import PreCollectionFilterLoading from '@/components/pre-collections/PreCollectionFilterLoading.vue';
import { getAllSubjects } from '@/utils/add-question/add-question-util';
import getLevelPremadePaper from '@/utils/common/get-level-premade-paper';
import MainButton from '@/main-components/common/MainButton.vue';
import Img from '@/main-components/common/Img.vue';
import FilterSortBy from '@/main-components/pre-collections-new/pre-collection-filter/FilterSortBy.vue';
import PreCollectionHighlight from '@/main-components/pre-collections-new/PreCollectionHighlight.vue';
import PreCollectionCustomList from '@/main-components/pre-collections-new/PreCollectionCustomList.vue';
import { delimiter } from '@/views/Browse.vue';
import VideoTutorial from '@/main-components/common/VideoTutorial.vue';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import { pageSEO } from '@/utils/seo';
import seoDefault from '@/utils/seo-default';
import TestBanner from '@/main-components/common/TestBanner.vue';

export interface SubjectBlock {
  name: string;
  path: string;
  isAvailable: boolean;
}

export interface PreCollectionCustom {
  title: string;
  preCollection: PreCollection[];
}

@Component({
  components: {
    PreCollectionSearch,
    PreCollectionSubject,
    PreCollectionFilterLoading,
    Img,
    MainButton,
    FilterSortBy,
    PreCollectionHighlight,
    PreCollectionCustomList,
    VideoTutorial,
    TestBanner,
  },
  metaInfo(this: HomeNew): MetaInfo {
    return {
      title: pageSEO.title.home,
      link: [
        {
          vmid: 'canonical',
          rel: 'canonical',
          href: pageSEO.canonical.home,
        },
      ],
      meta: [
        ...seoDefault({
          title: pageSEO.titleMeta.home,
          description: pageSEO.description.home,
        }),
      ],
    };
  },
})
export default class HomeNew extends Vue {
  preCollectionStore: PreCollectionStoreInterface = PreCollectionStore;

  isLoading = false;
  isLoadingSubject = true;
  isLoadingAddPreCollection = false;

  queries: PreCollectionsParams = this.resetQueries();

  availSubjects: Subject[] = [];

  preCollectionsCustom: PreCollectionCustom[] | null = [];

  dropdownSubjectInput = {
    name: 'subject',
    value: {
      selectedSubject: 'english',
      selectedForm: 999,
      selectedChapter: null,
      selectedChapters: [],
    },
    type: 'dropdown-subject',
    isRequired: true,
    isFormRequired: true,
    isHideChapter: true,
  };

  // change the input here to get the custom precollection list
  preCollectionsCustomInput = [
    {
      title: 'Kertas Popular',
      queries: {
        keyword: '',
        subjectType: SubjectType.All,
        sortBy: PreCollectionSortBy.Latest,
        preCollectionTypes: [PreCollectionType.Exam],
        years: [],
        levels: [],
      },
    },
    {
      title: 'Latihan Popular',
      queries: {
        keyword: '',
        subjectType: SubjectType.All,
        sortBy: PreCollectionSortBy.Latest,
        preCollectionTypes: [PreCollectionType.Practice],
        years: [],
        levels: [],
      },
    },
    {
      title: 'Course Popular',
      queries: {
        keyword: '',
        subjectType: SubjectType.All,
        sortBy: PreCollectionSortBy.Latest,
        preCollectionTypes: [PreCollectionType.Course],
        years: [],
        levels: [],
      },
    },
  ];

  beforeCreate() {
    this.$timeMpEvent(this.$mp_value.LoadTimeHome);
  }

  async created() {
    this.availSubjects = await getAllSubjects();
    this.isLoadingSubject = false;

    this.$sendMpEvent({
      event: this.$mp_value.LoadTimeHome,
    });
  }

  resetQueries() {
    const resetValue = {
      subjectUuid: 'all',
      keyword: '',
      subjectType: SubjectType.All,
      sortBy: PreCollectionSortBy.Latest,
      preCollectionTypes: preCollectionTypeList,
      years: [],
      levels: [],
    };

    this.queries = resetValue;

    return resetValue;
  }

  searchPreCollections() {
    if (this.isLoading) return;

    this.isLoading = true;

    this.$sendMpEvent({
      event: this.$mp_value.HomeCta,
      properties: {
        ...this.queries,
      },
    });

    this.updateQueryUrl(true);
  }

  updateQueryUrl(redirectToBrowsePage: boolean) {
    const queryUrls = {
      subject: this.queries.subjectUuid,
    };

    if (this.queries.levels.length) {
      queryUrls['level'] = null;
      const levels = this.queries.levels.map(level => {
        return getLevelPremadePaper(level)
          .replaceAll(' ', '_')
          .toLowerCase();
      });

      queryUrls['level'] = levels.join(delimiter);
    } else {
      queryUrls['level'] = null;
      delete queryUrls['level'];
    }

    if (this.queries.preCollectionTypes.length) {
      queryUrls['paper'] = this.queries.preCollectionTypes.join(delimiter);
    } else {
      queryUrls['paper'] = null;
      delete queryUrls['paper'];
    }

    if (this.queries.keyword) {
      queryUrls['keyword'] = this.queries.keyword;
    } else {
      queryUrls['keyword'] = null;
      delete queryUrls['keyword'];
    }

    if (this.queries.years.length) {
      queryUrls['year'] = this.queries.years.join(delimiter);
    } else {
      queryUrls['year'] = null;
      delete queryUrls['year'];
    }

    let isSameQuery = false;

    if (
      this.$route.query.subject === queryUrls.subject &&
      this.$route.query.level === queryUrls['level'] &&
      this.$route.query.paper === queryUrls['paper'] &&
      this.$route.query.keyword === queryUrls['keyword']
    ) {
      isSameQuery = true;
    }

    if (!isSameQuery && redirectToBrowsePage) {
      this.$router.push({
        path: '/browse',
        query: {
          ...queryUrls,
        },
      });
    }
  }
}
